var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table no-border" },
    [
      _vm.selectable
        ? _c(
            "tr",
            { staticClass: "bb-1 selectable-line" },
            _vm._l(_vm.lines[0], function(column, indexColumn) {
              return _c(
                "td",
                {
                  key: indexColumn,
                  staticClass: "br-1",
                  class: { "primary-05-bkg": _vm.isSelected(indexColumn) }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link semibold",
                      on: {
                        click: function($event) {
                          return _vm.selectColumn(indexColumn)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$l10n.__("Sélectionner")))]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.lines, function(line, index) {
        return _c(
          "tr",
          { key: index, staticClass: "bb-1" },
          _vm._l(line, function(column, indexColumn) {
            return indexColumn != "errors"
              ? _c(
                  "td",
                  {
                    key: indexColumn,
                    staticClass: "br-1 mw-96",
                    class: [
                      { "primary-05-bkg": _vm.isSelected(indexColumn) },
                      { error: _vm.hasError(indexColumn, line) }
                    ]
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.hasError(indexColumn, line)
                            ? line.errors[indexColumn]
                            : column
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          }),
          0
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }